import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const SUPPORT_WHATSAPP = '919958540416';
const SUPPORT_DISPLAY = '+91 99585 40416';

/**
 * Opens WhatsApp with a pre-filled support message.
 * @param {string} message - Pre-written message body
 */
export const openWhatsAppSupport = (message) => {
  const url = `https://wa.me/${SUPPORT_WHATSAPP}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

/**
 * Compact support block with message, WhatsApp number, and open button.
 */
const WhatsAppSupport = ({
  title = 'Need help?',
  description,
  message,
  sx = {}
}) => {
  return (
    <Box
      sx={{
        mt: 3,
        p: 2.5,
        borderRadius: 2,
        background: 'rgba(37, 211, 102, 0.08)',
        border: '1px solid rgba(37, 211, 102, 0.35)',
        textAlign: 'center',
        ...sx
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ color: '#25D366', fontWeight: 700, mb: 0.75 }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant="body2"
          sx={{ color: 'rgba(255, 255, 255, 0.75)', mb: 1.5, lineHeight: 1.5 }}
        >
          {description}
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 2, fontWeight: 600 }}
      >
        WhatsApp: {SUPPORT_DISPLAY}
      </Typography>
      <Button
        variant="contained"
        startIcon={<WhatsAppIcon />}
        onClick={() => openWhatsAppSupport(message)}
        sx={{
          background: '#25D366',
          color: '#fff',
          fontWeight: 700,
          textTransform: 'none',
          px: 3,
          py: 1,
          '&:hover': {
            background: '#1ebe57',
            boxShadow: '0 4px 16px rgba(37, 211, 102, 0.45)'
          }
        }}
      >
        Open WhatsApp
      </Button>
    </Box>
  );
};

export default WhatsAppSupport;
